
import apiClient from '../../../services/apiClient';
import { compactParams } from '../utils/documentUtils';

const schoolBase = (schoolId) => `/schools/${schoolId}`;
const documentsBase = (schoolId) => `${schoolBase(schoolId)}/documents`;

export const idCardApi = {
  getAcademicYears: (schoolId) =>
    apiClient.get(`${schoolBase(schoolId)}/academics/academic-years/`),

  getClassLevels: (schoolId, params = {}) =>
    apiClient.get(`${schoolBase(schoolId)}/academics/class-levels/`, {
      params: compactParams({
        academic_year_id: params.academicYearId ?? params.academic_year_id,
        status: params.status,
      }),
    }),

  getSections: (schoolId, params = {}) =>
    apiClient.get(`${schoolBase(schoolId)}/academics/sections/`, {
      params: compactParams({
        academic_year_id: params.academicYearId ?? params.academic_year_id,
        class_level_id: params.classLevelId ?? params.class_level_id,
        status: params.status,
      }),
    }),

  getCandidates: (schoolId, params = {}) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/candidates/`, {
      params: compactParams(params),
    }),

  validateCandidates: (schoolId, payload) =>
    apiClient.post(`${documentsBase(schoolId)}/id-cards/validate/`, payload),

  getTemplates: (schoolId, documentType) =>
    apiClient.get(`${documentsBase(schoolId)}/templates/`, {
      params: compactParams({ document_type: documentType }),
    }),

  getTemplateThumbnail: (schoolId, templateId) =>
    apiClient.get(`${documentsBase(schoolId)}/templates/${templateId}/thumbnail/`, {
      responseType: 'blob',
    }),

  getAvailableFields: (schoolId, ownerType) =>
    apiClient.get(`${documentsBase(schoolId)}/templates/available-fields/`, {
      params: { owner_type: ownerType },
    }),

  getTemplateSettings: (schoolId, templateId) =>
    apiClient.get(`${documentsBase(schoolId)}/templates/${templateId}/settings/`),

  updateTemplateSettings: (schoolId, templateId, payload) =>
    apiClient.patch(`${documentsBase(schoolId)}/templates/${templateId}/settings/`, payload),

  makeDefaultTemplate: (schoolId, templateId) =>
    apiClient.post(`${documentsBase(schoolId)}/templates/${templateId}/make-default/`),

  previewTemplate: (schoolId, templateId, payload) =>
    apiClient.post(
      `${documentsBase(schoolId)}/templates/${templateId}/preview/`,
      payload,
      { responseType: 'blob' },
    ),

  createGenerationJob: (schoolId, payload) =>
    apiClient.post(`${documentsBase(schoolId)}/id-cards/jobs/`, payload),

  getGenerationJobs: (schoolId, params = {}) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/jobs/`, {
      params: compactParams(params),
    }),

  getGenerationJob: (schoolId, jobId) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/jobs/${jobId}/`),

  cancelGenerationJob: (schoolId, jobId) =>
    apiClient.post(`${documentsBase(schoolId)}/id-cards/jobs/${jobId}/cancel/`),

  getGeneratedDocuments: (schoolId, params = {}) =>
    apiClient.get(`${documentsBase(schoolId)}/`, { params: compactParams(params) }),

  downloadGeneratedDocument: (schoolId, documentId) =>
    apiClient.get(`${documentsBase(schoolId)}/generated/${documentId}/download/`, {
      responseType: 'blob',
    }),

  getCardHistory: (schoolId, params = {}) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/`, {
      params: compactParams(params),
    }),

  getCard: (schoolId, cardId) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/${cardId}/`),

  downloadCard: (schoolId, cardId) =>
    apiClient.get(`${documentsBase(schoolId)}/id-cards/${cardId}/download/`, {
      responseType: 'blob',
    }),

  reissueCard: (schoolId, cardId, payload) =>
    apiClient.post(`${documentsBase(schoolId)}/id-cards/${cardId}/reissue/`, payload),

  revokeCard: (schoolId, cardId, payload) =>
    apiClient.post(`${documentsBase(schoolId)}/id-cards/${cardId}/revoke/`, payload),
};
